var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFunnelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 0.5H1.16667C0.989856 0.5 0.820286 0.570238 0.695262 0.695262C0.570238 0.820286 0.5 0.989856 0.5 1.16667V2.224C0.500038 2.4008 0.5703 2.57034 0.695333 2.69533L4.97133 6.97133C5.09637 7.09633 5.16663 7.26587 5.16667 7.44267V11.3127C5.16667 11.4613 5.21634 11.6056 5.30777 11.7228C5.39921 11.84 5.52717 11.9232 5.67133 11.9593L7.00467 12.2927C7.10297 12.3173 7.20559 12.3192 7.30473 12.2982C7.40387 12.2772 7.49692 12.2339 7.57681 12.1716C7.6567 12.1092 7.72133 12.0295 7.76578 11.9384C7.81023 11.8473 7.83333 11.7473 7.83333 11.646V7.44267C7.83337 7.26587 7.90363 7.09633 8.02867 6.97133L12.3047 2.69533C12.4297 2.57034 12.5 2.4008 12.5 2.224V1.16667C12.5 0.989856 12.4298 0.820286 12.3047 0.695262C12.1797 0.570238 12.0101 0.5 11.8333 0.5Z",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnelIcon);
export default __webpack_public_path__ + "static/media/filter_funnel_icon.fc4fb238691eb8d445329678cab6679a.svg";
export { ForwardRef as ReactComponent };